import { getAuth, initializeAuth, indexedDBLocalPersistence } from "firebase/auth";
import { Capacitor } from '@capacitor/core';

let firebaseApp = null;

export const setFirebaseApp = (app) => {
    firebaseApp = app;
};

export const whichAuth = () => {
    let auth;
    if (Capacitor.isNativePlatform()) {
        auth = initializeAuth(firebaseApp, {
            persistence: indexedDBLocalPersistence
        })
    } else {
        auth = getAuth();
    }
    return auth
};
